module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "front-header"
  }, [_c('button', {
    staticClass: "skip-to-content",
    on: {
      "click": _vm.skipToContent
    }
  }, [_vm._v("Skip to content")]), _vm._v(" "), (_vm.isShownCookiesNot) ? _c('div', {
    staticClass: "front-header-cookies"
  }, [_c('div', {
    staticClass: "front-cookies-container"
  }, [_c('div', {
    staticClass: "front-header-cookies-content"
  }, [_vm._v("\n        This website uses cookies, so we can improve your experience here.\n        By continuing to browse the site, you are agreeing to our use of cookies.\n        Read more about this in our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'cookies'
      }
    }
  }, [_vm._v("Cookies Policy")])], 1), _vm._v(" "), _c('div', {
    staticClass: "front-header-cookies-control"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setCookiesPermission
    }
  }, [_vm._v("I agree")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "front-header-top"
  }, [_c('div', {
    staticClass: "myContainer front-header-top__inner"
  }, [_c('router-link', {
    staticClass: "front-header-logo",
    class: this.customLogo ? 'industry-logo' : '',
    style: ({
      backgroundImage: this.customLogo ? 'url(' + _vm.getFullServerPath(this.customLogo) + ')' : ''
    }),
    attrs: {
      "to": "/",
      "title": "The Clear Company logo"
    }
  }), _vm._v(" "), (!_vm.getDeviceType('mobile')) ? _c('ul', {
    staticClass: "front-header-menu"
  }, [_vm._l((_vm.headerData), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "login-trigger"
  }, [_c('button', {
    class: [{
      'active': this.loginOpen
    }],
    attrs: {
      "aria-label": "Login",
      "aria-haspopup": "dialog",
      "aria-expanded": this.loginOpen
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openSubmenu('login')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.loginOpen && !_vm.getDeviceType('mobile')),
      expression: "this.loginOpen && !getDeviceType('mobile')"
    }],
    ref: "loginContainer",
    staticClass: "front-header-login",
    class: [{
      'has-error': _vm.isError || _vm.errors.has('Email') || _vm.errors.has('Password')
    }],
    attrs: {
      "aria-label": "Login",
      "role": "dialog"
    }
  }, [_c('form', {
    staticClass: "front-header-login-inner",
    attrs: {
      "aria-label": "Login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.authenticate()
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: [{
      'active': _vm.loginData.email !== '' || _vm.emailFocus,
      'has-error': _vm.isError || _vm.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "header-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.email),
      expression: "loginData.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "header-login-input email-type",
    class: [{
      'border-1-50': _vm.loginData.email !== '' || _vm.emailFocus,
      'has-error': _vm.isError || _vm.errors.has('Email')
    }],
    attrs: {
      "id": "header-email",
      "data-vv-name": "Email",
      "title": "Login email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.loginData.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: [{
      'active': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError || _vm.errors.has('Password')
    }]
  }, [_c('label', {
    attrs: {
      "for": "header-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "front-header-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword()
      }
    }
  }), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "header-login-input password-type",
    class: [{
      'border-1-50': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError || _vm.errors.has('Password')
    }],
    attrs: {
      "id": "header-password",
      "data-vv-name": "Password",
      "title": "Login password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginData.password) ? _vm._i(_vm.loginData.password, null) > -1 : (_vm.loginData.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.loginData.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginData, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginData, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginData, "password", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "header-login-input password-type",
    class: [{
      'border-1-50': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError || _vm.errors.has('Password')
    }],
    attrs: {
      "id": "header-password",
      "data-vv-name": "Password",
      "title": "Login password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.loginData.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.loginData, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "header-login-input password-type",
    class: [{
      'border-1-50': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError || _vm.errors.has('Password')
    }],
    attrs: {
      "id": "header-password",
      "data-vv-name": "Password",
      "title": "Login password",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-error",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.errors.has('Email')) ? _c('span', [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e(), _vm._v(" "), (this.errors.has('Password')) ? _c('span', [_vm._v(_vm._s(this.errors.first('Password')))]) : _vm._e(), _vm._v(" "), (_vm.loginInProgress) ? _c('span', {
    staticClass: "visually-hidden"
  }, [_vm._v("Submitting")]) : _vm._e(), _vm._v(" "), (_vm.loginErrorMessage) ? _c('span', [_vm._v(_vm._s(_vm.loginErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "front-header-login-actions"
  }, [_c('button', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.loginInProgress
    }]
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      },
      "title": "Forgot password"
    }
  }, [_vm._v("Forgot password?")])], 1)])])]), _vm._v(" "), _c('li', {
    staticClass: "accessibility-trigger"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": "Open accessibility"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.openSubmenu('accessibility')
      }
    }
  }), _vm._v(" "), (this.accessibilityOpen && !_vm.getDeviceType('mobile')) ? _c('div', {
    ref: "accessibilityContainer",
    staticClass: "front-header-capabilities"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "front-header-capabilities-inner"
  }, [_c('ul', {
    staticClass: "text-resize-controls"
  }, [_c('li', [_c('button', {
    staticClass: "text-resize-controls__button text-resize-controls__normal",
    attrs: {
      "id": "accessibilityFontSize_0",
      "title": "Normal text size"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resizeText(0)
      }
    }
  }, [_vm._v("A")])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "text-resize-controls__button text-resize-controls__medium",
    attrs: {
      "id": "accessibilityFontSize_1",
      "title": "Medium text size"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resizeText(1)
      }
    }
  }, [_vm._v("A")])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "text-resize-controls__button text-resize-controls__large",
    attrs: {
      "id": "accessibilityFontSize_2",
      "title": "Big text size"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resizeText(2)
      }
    }
  }, [_vm._v("A")])])]), _vm._v(" "), _c('div', {
    staticClass: "color-change-controls"
  }, [_c('button', {
    staticClass: "color-change-controls__button color-change-controls__normal",
    attrs: {
      "id": "accessibilityColorPalette_0",
      "title": "Normal view"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVisibilityThem(0)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "color-change-controls__button color-change-controls__contrast",
    attrs: {
      "id": "accessibilityColorPalette_1",
      "title": "High contrast view"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVisibilityThem(1)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "color-change-controls__button color-change-controls__dyslexia",
    attrs: {
      "id": "accessibilityColorPalette_2",
      "title": "Dyslexia friendly view"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVisibilityThem(2)
      }
    }
  })])])]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('a', {
    staticClass: "front-header-mobile-menu-trigger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.mobileMenuShown = !_vm.mobileMenuShown
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.mobileMenuShown && _vm.getDeviceType('mobile')) ? _c('div', {
    ref: "mobileMenuContainer",
    staticClass: "front-header-mobile-menu",
    class: [{
      'login-opened': this.mobileLoginOpen
    }]
  }, [_c('div', {
    staticClass: "front-header-mobile-menu-inner"
  }, [_c('div', {
    staticClass: "color-change-controls"
  }, [_c('button', {
    staticClass: "color-change-controls__button color-change-controls__normal",
    attrs: {
      "id": "accessibilityColorPalette_0",
      "title": "Normal view"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVisibilityThem(0)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "color-change-controls__button color-change-controls__contrast",
    attrs: {
      "id": "accessibilityColorPalette_1",
      "title": "High contrast view"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVisibilityThem(1)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "color-change-controls__button color-change-controls__dyslexia",
    attrs: {
      "id": "accessibilityColorPalette_2",
      "title": "Dyslexia friendly view"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVisibilityThem(2)
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "front-header-mobile-menu-items"
  }, [_vm._l((_vm.headerData), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "login-trigger"
  }, [_c('a', {
    class: [{
      'active': this.mobileLoginOpen
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobileLoginOpen = !_vm.mobileLoginOpen
      }
    }
  }, [_vm._v("Login")])])], 2), _vm._v(" "), (_vm.mobileLoginOpen && _vm.getDeviceType('mobile')) ? _c('div', {
    ref: "loginContainer",
    staticClass: "front-header-login"
  }, [_c('div', {
    staticClass: "front-header-login-inner"
  }, [_c('div', {
    staticClass: "form-group",
    class: [{
      'active': _vm.loginData.email !== '' || _vm.emailFocus,
      'has-error': _vm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "header-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.email),
      expression: "loginData.email"
    }],
    staticClass: "header-login-input email-type",
    class: [{
      'border-1-50': _vm.loginData.email !== '' || _vm.emailFocus,
      'has-error': _vm.isError
    }],
    attrs: {
      "id": "header-email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.loginData.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: [{
      'active': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError
    }]
  }, [_c('label', {
    attrs: {
      "for": "header-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "front-header-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword()
      }
    }
  }), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    staticClass: "header-login-input password-type",
    class: [{
      'border-1-50': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError
    }],
    attrs: {
      "id": "header-password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.loginData.password) ? _vm._i(_vm.loginData.password, null) > -1 : (_vm.loginData.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.loginData.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.loginData, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.loginData, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.loginData, "password", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    staticClass: "header-login-input password-type",
    class: [{
      'border-1-50': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError
    }],
    attrs: {
      "id": "header-password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.loginData.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.loginData, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    staticClass: "header-login-input password-type",
    class: [{
      'border-1-50': _vm.loginData.password !== '' || _vm.passwordFocus,
      'has-error': _vm.isError
    }],
    attrs: {
      "id": "header-password",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate()
      },
      "focus": function($event) {
        _vm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isError) ? _c('div', {
    staticClass: "login-form-error"
  }, [_vm._v("\n                " + _vm._s(_vm.loginErrorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "front-header-login-actions"
  }, [_c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.loginInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate()
      }
    }
  }, [_vm._v("Login")])], 1)])]) : _vm._e()])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reciteMe-container"
  }, [_c('button', {
    staticClass: "reciteme background-1-100",
    attrs: {
      "id": "reciteMe"
    }
  }, [_vm._v("Speak or translate")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41190443","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/common/AuthorizationHeader.vue
// module id = 920
// module chunks = 1